import { render, staticRenderFns } from "./v_award.vue?vue&type=template&id=a1a653c2&scoped=true"
import script from "./v_award.vue?vue&type=script&lang=js"
export * from "./v_award.vue?vue&type=script&lang=js"
import style0 from "./v_award.vue?vue&type=style&index=0&id=a1a653c2&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1a653c2",
  null
  
)

export default component.exports